<template>
  <div class="home">
    <div class="box ">
        <el-carousel :interval="5000" arrow="always" loop>
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <div style="height: 300px;">
                    <img :src="item.url" alt="加载失败" width="100%" height="100%">
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="wrap">
            <div class="content">
                <h2>引流池平台服务介绍</h2>
                <p>轻松推广店铺 只需一步 免费获取流量 就是这么简单！</p>
            </div>
            <div class="service">
                <ul>
                    <li v-for="(item, index) in menuList" :key="index">
                        <div class="txt-center">
                            <img :src="item.url" alt="">
                        </div>
                        <div>
                            <h3>{{item.title}}</h3>
                        </div>
                        <div>
                            <span v-html="item.text"></span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
  </div>
</template>
<script>

export default {

  data () {
    return {
      bannerList: [
        {
          href: '#',
          url: require('./../../assets/images/banner/banner1.png')
        },
        {
          href: '#',
          url: require('./../../assets/images/banner/banner2.png')
        }
      ],
      menuList: [
        {
          url: require('./../../assets/images/home/icon_001.png'),
          title: '支持全平台',
          text: '快速提升淘宝/天猫/京</br>东/拼多多等平台人气</br>流量收藏加购等多类型</br>任务'
        },
        {
          url: require('./../../assets/images/home/icon_002.png'),
          title: '多入口流量',
          text: '快速提升淘宝/天猫/京</br>东/拼多多等平台人气</br>流量收藏加购等多类型</br>任务'
        },
        {
          url: require('./../../assets/images/home/icon_003.png'),
          title: '店铺收藏商品',
          text: '买家无线端搜索关键词</br>进店深度游览，操作收</br>藏流量收藏加购等多</br>类型任务'
        },
        {
          url: require('./../../assets/images/home/icon_004.png'),
          title: '加入购物车',
          text: '买家无线端搜索关键词</br>进店深度游览，操作宝</br>贝加入购物车，增加商</br>品回购率和权重'
        },
        {
          url: require('./../../assets/images/home/icon_005.png'),
          title: '深度游览',
          text: '进店后游览到底部，游</br>览副宝贝及评价，全网</br>首家超长停留时间最多</br>停留400秒且免费选择'
        }
      ]
    }
  },
  methods: {

  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.content {
    text-align: center;
    h2 {
        font-size: 30px;
        color: #FF8301;
    }
    p {
        font-size: 18px;
        color: #666666;
        margin-top: 10px;
    }
}
.wrap {
    background: #fff;
    padding-top: 60px;
    padding-bottom: 60px;
}
.service {
    margin-top: 75px;
    ul{
        display: flex;
        justify-content: space-between;
        padding: 0 100px;
        li {
            text-align: center;
            h3 {
                font-size: 24px;
                color: #333333;
                margin-top: 15px;
                margin-bottom: 15px;
            }
            span {
                font-size: 14px;
                color: #666666;
                line-height: 1.4;
            }
        }
    }
}
/deep/ .el-carousel--horizontal{
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue